import React, { useEffect, useState } from "react";
import CustomSelect from "../../../../Base/CustomSelect";
import BarChart from "./BarChart";
import { statsType } from "../../../../utils/constants";

const LABELS = ["Jan", "Feb", "Mar", "Apr", "May", "June", "Jul"];
export default function ChartOuter({
  timePeriod,
  setTimePeriod,
  list,
  setTypeOfStats,
  typeOfStats,
  stats,
}) {
  const [labels, setLabels] = useState(LABELS);
  const [cartData, setChartData] = useState([
    6000, 2000, 5500, 7000, 4000, 8000, 5200,
  ]);

  const getMonthLables = (date) => {
    const currentDate = new Date(date);
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    return `${day}/${month}`;
  };
  const getYearLables = (date) => {
    const currentDate = new Date(date);
    const month = currentDate.getMonth() + 1;
    return month;
  };
  useEffect(() => {
    const c = stats.map(({ revenueUsd }) => revenueUsd);
    setChartData(c);
    if (timePeriod.value === "Day") {
      const l = stats.map(({ timestamp }) => getMonthLables(timestamp));
      setLabels(l);
    } else if (timePeriod.value === "Month") {
      const l = stats.map(({ timestamp }) => getMonthLables(timestamp));
      setLabels(l);
    } else if (timePeriod.value === "Week") {
      const l = stats.map(({ timestamp }) => getMonthLables(timestamp));
      setLabels(l);
    } else if (timePeriod.value === "Year") {
      const l = stats.map(({ timestamp }) => getYearLables(timestamp));
      setLabels(l);
    }
  }, [stats]);
  return (
    <div className="chart box">
      <div className="chart__head">
        <div className="chart__head-row">
          <h4 className="big">Payment requests</h4>
          <CustomSelect
            list={list}
            currentSelected={timePeriod}
            setCurrentSelected={setTimePeriod}
          />
          <CustomSelect
            list={statsType}
            currentSelected={typeOfStats}
            setCurrentSelected={setTypeOfStats}
          />
        </div>
        <div className="chart__head-price">
          $
          {stats.reduce((accumulator, currentValue) => {
            return accumulator + parseFloat(currentValue.revenueUsd);
          }, 0)}
        </div>
      </div>
      <div className="chart__body">
        <BarChart labels={labels} data={cartData} />
      </div>
    </div>
  );
}
